$('.tabs .nav a').on('click', function(e){
  e.preventDefault();
  $('.tabs .nav a, .tabs .panel').removeClass('active');
  $(this).addClass('active');
  $($(this).attr('href')).addClass('active');
});